(function () {
  const container = document.querySelector("[data-mega-menu-container]");
  if (!container) return;

  const triggers = container.querySelectorAll("[data-mega-menu-trigger]");
  let closeTimeout = null;
  let activePanel = null;
  let activeTrigger = null;

  function openMenu(trigger, panel) {
    clearTimeout(closeTimeout);
    if (activePanel && activePanel !== panel) {
      closeMenu(activeTrigger, activePanel);
    }
    trigger.setAttribute("aria-expanded", "true");
    panel.setAttribute("data-open", "");
    activePanel = panel;
    activeTrigger = trigger;
  }

  function closeMenu(trigger, panel) {
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    if (panel) panel.removeAttribute("data-open");
    if (activePanel === panel) {
      activePanel = null;
      activeTrigger = null;
    }
  }

  triggers.forEach((trigger) => {
    const li = trigger.closest("li");
    const panelId = trigger.getAttribute("aria-controls");
    const panel = document.getElementById(panelId);
    if (!li || !panel) return;

    li.addEventListener("mouseenter", () => {
      openMenu(trigger, panel);
    });

    li.addEventListener("mouseleave", () => {
      closeTimeout = setTimeout(() => {
        closeMenu(trigger, panel);
      }, 150);
    });

    panel.addEventListener("mouseenter", () => {
      clearTimeout(closeTimeout);
      openMenu(trigger, panel);
    });

    panel.addEventListener("mouseleave", () => {
      closeTimeout = setTimeout(() => {
        closeMenu(trigger, panel);
      }, 150);
    });

    li.addEventListener("focusin", () => {
      openMenu(trigger, panel);
    });

    li.addEventListener("focusout", (e) => {
      if (!li.contains(e.relatedTarget) && !panel.contains(e.relatedTarget)) {
        closeMenu(trigger, panel);
      }
    });

    panel.addEventListener("focusin", () => {
      clearTimeout(closeTimeout);
      openMenu(trigger, panel);
    });

    panel.addEventListener("focusout", (e) => {
      if (!panel.contains(e.relatedTarget) && !li.contains(e.relatedTarget)) {
        closeMenu(trigger, panel);
      }
    });

    panel.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeMenu(trigger, panel);
        trigger.focus();
      }
    });

    trigger.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        closeMenu(trigger, panel);
      }
    });
  });
})();
